<template>
  <div class="title-block">{{ $t("app.modals.restoreCampaign.subtitle") }}</div>
  <p class="under-text">{{ $t("app.modals.restoreCampaign.text") }}</p>
  <div class="input-wrapper">
    <label v-text="$t('app.modals.restoreCampaign.workspace.label')" />
    <v-select id="campaign-space" :placeholder="$t('app.modals.restoreCampaign.workspace.placeholder')" name="campaign-space" label="name" v-model="state.space" :clearable="false" :options="isSpacesPending ? [] : spaces">
      <template v-slot:no-options="{ search, searching }">
        <div style="padding: 8px 0">{{ $t("app.modals.restoreCampaign.noResult", { search }) }}</div>
      </template>
    </v-select>
  </div>
  <div class="btn-container">
    <Button class="secondary outline" :label="$t('app.archiveModal.buttons.cancel')" @click="emits('close')" />
    <Button class="primary" :label="$t('app.company.archives.restoreCampaign')" :loading="state.btnIsLoading" :disabled="!state.space" @click="restore" />
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";

import ToastContent from "@/components/global/ToastContent.vue";

import { Campaign } from "@/types/campaign";
import { useRestoreCampaign } from "@/queries/campaigns.query";
import { useSpaces } from "@/queries/space.query";

const emits = defineEmits(["close", "confirm"]);

const route = useRoute();
const toast = useToast();
const { t } = useI18n();

const { data: spaces, isPending: isSpacesPending } = useSpaces();
const { mutateAsync: restoreCampaign } = useRestoreCampaign();

const state = reactive({
  btnIsLoading: false,
  space: null,
});

const props = defineProps<{
  data: Campaign,
}>();

async function restore() {
  state.btnIsLoading = true;

  await restoreCampaign({
    context: {
      organisationId: route.params.companyId as string,
      campaignId: props.data.id,
    },
    spaceId: state.space.workspace_id,
  }, {
    onError: (error) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success({
        component: ToastContent,
        props: {
          text: t("app.modals.restoreCampaign.toasts.success", { campaign: props.data.campaign.internal_name, workspace: state.space.name }),
        },
        closeOnClick: false,
      });
    }
  });

  emits("confirm");

  state.btnIsLoading = false;
}
</script>
